module.exports = __webpack_public_path__ + "img/female_S_02.56903d8a.png";